export default __webpack_public_path__ + "static/media/store-appearance-phone-header.4ad66032.svg";